/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorAccountAttachPhoneNumberoRoutePlanMutation($vendorAccountId: ID!, $routePlanId: [ID!]!) {
  VendorAccountAttachPhoneNumberoRoutePlan(routePlanId: $routePlanId, vendorAccountId: $vendorAccountId) {
    message
    status
  }
}
`
